module.exports = __webpack_public_path__ + "img/nature-69.25dc5a54.jpg";